import { AgreementType, CurrentAgreementQuery, CurrentAgreementQueryVariables } from "@ctypes";
import { CURRENT_AGREEMENT } from "@graphql/queries";
import { useQuery } from "@hooks/apollo";

/** The agreement version in force for a type; the consent mutation needs its id. */
export const useCurrentAgreement = (type: AgreementType) => {
  return useQuery<CurrentAgreementQuery, CurrentAgreementQueryVariables>(CURRENT_AGREEMENT, {
    variables: { type },
  });
};
